import { colors, elevation } from '@atlaskit/theme';
import React from 'react';
import styled from 'styled-components';

import { iconContainerStyle } from '../style';

interface Props {
  icon: typeof React.Component;
}

export const DEFAULT_ICON_PROPS = {
  iconColor: colors.B200,
  iconGradientStart: colors.B400,
  iconGradientStop: colors.B200,
  size: 'xlarge',
  textColor: colors.N700,
};

export const Container = styled.div`
  ${iconContainerStyle};

  ${elevation.e200};
  transition: box-shadow 0.25s;

  &:hover {
    ${elevation.e400};
  }
`;

export default class ProductIcon extends React.Component<Props> {
  render() {
    const Icon = this.props.icon;
    return (
      <Container>
        <Icon {...DEFAULT_ICON_PROPS} />
      </Container>
    );
  }
}
